import React from "react";
import title_icon from '../../assets/title_icon.png';
import "./index.scss";

const Title = ({ title, title_en, type }) => {
  return (
    <div className={`page-title2 ${type === 'small' ? 'page-title-small' : ''}`}>
      <div>
        <img src={title_icon} alt="" className="mr8" />
      </div>
      <span className="title_txt mr4">{title}</span>
      <span className="title_txt_en">{title_en}</span>
    </div>
  );
};

export default Title;
